import { Carousel } from "react-responsive-carousel";
import { DiscountFlag } from "../../../components/DiscountFlag";
import CopyToClipboard from "react-copy-to-clipboard";
import IconesNovos from "../../../components/NewIcones/IconesNovos";
import NoImg from "../../../assets/images/no-image.png";
import { useState } from "react";
import { useToast } from "../../../hooks/useToast";
import { useLocation } from "react-router-dom";
import "../index.css";


type VariationImageType = {
    image: string;
    sku: string;
    order: number;
};

type PropsProductImage = {
    price: number;
    promotionalPrice: number;
    showFlag: boolean;
    config: any;
    variationImagesNow: VariationImageType[];
    goToLastImagem: number;
    setModalImage: (value: boolean) => void;
    setUrlImageOpen: (value: string) => void;
    animate: boolean;
    handleAnimation: (type: string) => void;

}

export function ProductImage({ price, promotionalPrice, showFlag, config, variationImagesNow, goToLastImagem, setModalImage, setUrlImageOpen, animate, handleAnimation }: PropsProductImage) {
    const { openToast } = useToast();
    const location = useLocation();
    const [loadingImage, setLoadingImage] = useState(true);



    return (
        <div className="product-image relative">
            {promotionalPrice !== 0 &&
                promotionalPrice !== price &&
                showFlag ? (
                <DiscountFlag
                    type={
                        config?.content.flagDiscount
                            ? config?.content.flagDiscount
                            : "trigonal"
                    }
                    color={
                        config?.webappcolor.flagDiscountColor
                            ? config?.webappcolor.flagDiscountColor
                            : "#000"
                    }
                    value={parseInt(
                        (((price - promotionalPrice) / price) * 100).toFixed(2)
                    )}
                    isDetailProductPage
                    isList={false}
                />
            ) : (
                <></>
            )}
            <div id="list-images">
                <Carousel
                    key={`${variationImagesNow
                        .map((img) => img.image)
                        .join(",")}-${Date.now()}`}
                    showThumbs={false}
                    showStatus={false}
                    showArrows={true}
                    selectedItem={goToLastImagem ?? 0} // Sempre começar do primeiro item quando mudar
                    swipeable={true}
                    preventMovementUntilSwipeScrollTolerance={true}
                    swipeScrollTolerance={50}
                >
                    {variationImagesNow.length === 0
                        ? [
                            <div
                                className={`w-full flex justify-center product-image-carousel`}
                                style={
                                    loadingImage
                                        ? {
                                            visibility: "hidden",
                                            width: 0,
                                            height: 0,
                                        }
                                        : {}
                                }
                                onLoad={() => {
                                    setLoadingImage(false);
                                }}
                                key={"no-image"}
                                onClick={() => {
                                    setModalImage(true);
                                    setUrlImageOpen(NoImg);
                                }}
                            >
                                <img
                                    src={NoImg}
                                    className={`rounded-medium object-contain`}
                                    alt="Sem imagem"
                                />
                            </div>,
                        ]
                        : variationImagesNow.map((variationImg) => (
                            <div
                                className={`w-full flex justify-center product-image-carousel`}
                                style={
                                    loadingImage
                                        ? {
                                            visibility: "hidden",
                                            width: 0,
                                            height: 0,
                                        }
                                        : {}
                                }
                                onLoad={() => {
                                    setLoadingImage(false);
                                }}
                                key={variationImg.image}
                                onClick={() => {
                                    setModalImage(true);
                                    setUrlImageOpen(variationImg.image || NoImg);
                                }}
                            >
                                <img
                                    src={variationImg.image || NoImg}
                                    className={`rounded-medium object-contain`}
                                    alt={variationImg.image || "Sem imagem"}
                                />
                            </div>
                        ))}
                </Carousel>
            </div>

            {/* Ícone de Compartilhar */}
            <div className="share-float-btn">
                <CopyToClipboard
                    text={window.location.origin + location.pathname}
                    onCopy={() => {
                        handleAnimation("share");
                        openToast("success", "Link copiado com sucesso!");
                    }}
                >
                    <button className={animate ? "pulse-animation" : ""}>
                        <IconesNovos
                            cor={"#222"}
                            active={true}
                            type={"plane"}
                            action={() => { }}
                        />
                    </button>
                </CopyToClipboard>
            </div>
        </div>
    )
}